var React = require('react');

function IcAdd24px (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z","key":0}),React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":1})]);
}

IcAdd24px.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IcAdd24px;

IcAdd24px.default = IcAdd24px;
